export default __webpack_public_path__ + "static/media/gitlab.83df9efb.svg";